export const APP_NAME = 'Popular Pays';

function setDocumentTitle(...parts: string[]) {
  document.title = parts.length
    ? `${APP_NAME} | ${parts.join(' > ')}`
    : APP_NAME;
}

export default setDocumentTitle;
